/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
/**
 * Wrap window.location so that it's testable.
 */

const getLocation = (): Location | undefined => {
	if (typeof window !== 'undefined') {
		return window.location;
	}
	return undefined;
};

export default getLocation;
